import useScript from "../../../hooks/useScript";
import { useEffect, useCallback, useRef } from "react";
import { EmbedFacebookService } from "../../../services/embed-facebook";
import { useScreenOrientationChange } from "../../../hooks/useScreenOrientationChange";

export default function Facebook({ id }: { id: string }): JSX.Element {
  try {
    useScript("https://connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v20.0");

    const embedRef = useRef(null);
    const embedHref = EmbedFacebookService.getEmbedHref({ url: id });
    const embedType = EmbedFacebookService.getEmbedType({ href: embedHref });
    const embedAttributes = EmbedFacebookService.getEmbedAttributes({ href: embedHref, postType: embedType });

    const handleRenderEmbed = useCallback(() => {
      /**
       * Timeout added because window.FB.XFBML.parse need
       * a brief moment to find out that Screen Orientation changed
       *
       * Also, it makes a little bit of optimization for Interaction to Next Paint
       */
      setTimeout(() => {
        if (window.FB && embedRef.current) {
          window.FB.XFBML.parse(embedRef.current);
        }
      }, 50);
    }, [embedRef]);

    useEffect(handleRenderEmbed, [handleRenderEmbed]);
    useScreenOrientationChange({ callback: handleRenderEmbed });

    return (
      <div className="facebook-post" ref={embedRef}>
        <div {...embedAttributes} />
      </div>
    );
  } catch (e) {
    console.error("RTC / Embeds / Facebook: Rendering the Facebook Post Embed failed!", id, e);
    return <></>;
  }
}
